import { Trans } from '@lingui/react';
import { I18n } from '@lingui/core';
import { PaymentKind } from '@startuptools/common/participants';
import { ReactNode } from 'react';

export const paymentKindHuman: Record<PaymentKind, ReactNode> = {
  [PaymentKind.Cash]: <Trans id="Cash" />,
  [PaymentKind.Offset]: <Trans id="By offset" />,
  [PaymentKind.NonCash]: <Trans id="By in-kind" />,
};

export const paymentKindHumanString: (i18n: I18n) => Record<PaymentKind, string> = i18n => ({
  [PaymentKind.Cash]: i18n.t('Cash'),
  [PaymentKind.Offset]: i18n.t('By offset'),
  [PaymentKind.NonCash]: i18n.t('By in-kind'),
});

export const PaymentKindHuman = ({ children }: { children: PaymentKind }) => {
  return paymentKindHuman[children];
};
